import { render } from "./CurrencySelect.vue?vue&type=template&id=c4c33006&scoped=true"
import script from "./CurrencySelect.vue?vue&type=script&lang=js"
export * from "./CurrencySelect.vue?vue&type=script&lang=js"

import "./CurrencySelect.vue?vue&type=style&index=0&id=c4c33006&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4c33006"]])

export default __exports__